// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"37607d92","178":"48e95fe9","210":"70e3e300","263":"afc94da3","291":"4248f4da","296":"991fcee8","318":"533957a6","457":"f1ba19a8","657":"654c02bc","722":"99ab8f6c","753":"84748f5d","816":"de70089d","861":"328debd4","902":"4a17a868"}[chunkId] + ".chunk.js";
};